var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientRadarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7148 1.217C18.3265 0.82871 17.7098 0.82871 17.3215 1.217C16.9332 1.60528 16.9332 2.22197 17.3215 2.61026C20.7932 6.082 20.7932 11.7236 17.3215 15.1953C16.9332 15.5836 16.9332 16.2003 17.3215 16.5886C17.5042 16.7713 17.7555 16.8855 18.0067 16.8855C18.2579 16.8855 18.5092 16.7941 18.6919 16.5886C22.9402 12.3403 22.9402 5.44475 18.7148 1.217Z",
    fill: "url(#paint0_linear_5188_95154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4511 4.46309C15.0628 4.0748 14.4461 4.0748 14.0578 4.46309C13.6695 4.85138 13.6695 5.46807 14.0578 5.85635C15.7252 7.5237 15.748 10.2646 14.0578 11.9319C13.6695 12.3202 13.6695 12.9369 14.0578 13.3252C14.2405 13.5079 14.4918 13.6221 14.743 13.6221C14.9943 13.6221 15.2455 13.5307 15.4282 13.3252C17.9156 10.8812 17.8927 6.90473 15.4511 4.46309Z",
    fill: "url(#paint1_linear_5188_95154)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76159 2.6127C5.14987 2.22441 5.14987 1.60772 4.76159 1.21944C4.3733 0.831151 3.75661 0.831151 3.36832 1.21944C-0.857149 5.44491 -0.857149 12.3427 3.36832 16.5682C3.55105 16.7509 3.80229 16.8651 4.05353 16.8651C4.30478 16.8651 4.55602 16.7737 4.73875 16.5682C5.12703 16.1799 5.12703 15.5632 4.73875 15.1749C1.28985 11.726 1.28985 6.08444 4.76159 2.6127Z",
    fill: "url(#paint2_linear_5188_95154)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00453 5.85635C8.39281 5.46807 8.39281 4.85138 8.00453 4.46309C7.61624 4.0748 6.99955 4.0748 6.61126 4.46309C4.16734 6.90701 4.16734 10.8812 6.61126 13.3252C6.79398 13.5079 7.04523 13.6221 7.29647 13.6221C7.54772 13.6221 7.79896 13.5307 7.98169 13.3252C8.36997 12.9369 8.36997 12.3202 7.98169 11.9319C6.33718 10.2646 6.33718 7.5237 8.00453 5.85635Z",
    fill: "url(#paint3_linear_5188_95154)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0404 10.5613C11.9612 10.5613 12.7077 9.81476 12.7077 8.89391C12.7077 7.97306 11.9612 7.22656 11.0404 7.22656C10.1195 7.22656 9.37305 7.97306 9.37305 8.89391C9.37305 9.81476 10.1195 10.5613 11.0404 10.5613Z",
    fill: "url(#paint4_linear_5188_95154)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5188_95154",
    x1: 21.4823,
    y1: 5.97992,
    x2: 16.9664,
    y2: 6.11482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5188_95154",
    x1: 16.9985,
    y1: 7.16458,
    x2: 13.7217,
    y2: 7.28459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5188_95154",
    x1: 4.65381,
    y1: 5.97513,
    x2: 0.135295,
    y2: 6.11038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5188_95154",
    x1: 8.00659,
    y1: 7.16458,
    x2: 4.73344,
    y2: 7.28432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5188_95154",
    x1: 12.4336,
    y1: 8.2826,
    x2: 9.35608,
    y2: 8.58507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA54A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317304,
    stopColor: "#993393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4673,
    stopColor: "#8D278E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5944,
    stopColor: "#7B298F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#4D2E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientRadarIcon);
export default __webpack_public_path__ + "static/media/gradient_radar_icon.43b379f5ff01c2f3f82d8c4eda3c8fd3.svg";
export { ForwardRef as ReactComponent };